import { createFileRoute, Navigate } from '@tanstack/react-router'
import { RoleRestrictedContent } from '@/components/molecules/RoleRestrictedContent/RoleRestrictedContent'
import { UserType } from '@/hooks'
import { Interval } from '@/features/ActiveManagement/components/Interval/Interval'

export const Route = createFileRoute('/_layout/active-management/interval')({
    component: RouteComponent,
})

function RouteComponent() {
    return (
        <>
            <RoleRestrictedContent
                allowedRoles={[UserType.AGENT, UserType.BROKER]}
            >
                <Navigate to={'/dashboard'} />
            </RoleRestrictedContent>

            <RoleRestrictedContent
                allowedRoles={[UserType.CUSTOMER]}
                strict={false}
            >
                <Interval />
            </RoleRestrictedContent>
        </>
    )
}
